import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Link, Typography, Button } from '@one-thd/sui-atomic-components';

const NoOrdersView = ({
  setOpenAddReceiptModal,
  customerType,
  activeFilter,
}: {
  setOpenAddReceiptModal: (value: boolean) => void;
  customerType: string;
  activeFilter: boolean;
}) => {
  const navigate = useNavigate();
  return (
    <div className="sui-grid sui-grid-cols-1 sui-gap-6">
      <div>
        <div className="sui-mb-2">
          <Typography weight="bold">
            {activeFilter
              ? 'There are no purchases found for the selected dates.'
              : 'Try selecting another date filter to view your orders.'}
          </Typography>
        </div>
        <div className="sui-flex sui-flex-col sui-gap-8 md:sui-w-[600px]">
          <div className="sui-flex">
            <Typography>
              You can see all of your purchases made online or in-store here.
              Add a registered card to your{' '}
              <Link onClick={() => navigate('/myaccount/payments')}>
                Cards & Accounts
              </Link>
              {customerType === 'b2c' ? null : (
                <>
                  , or{' '}
                  <Link onClick={() => setOpenAddReceiptModal(true)}>
                    Add a Receipt
                  </Link>{' '}
                  to see in-store purchases
                </>
              )}
              .
            </Typography>
          </div>
          <Button href="https://www.homedepot.com" variant="primary">
            Start Shopping
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NoOrdersView;
